module.exports = __webpack_public_path__ + "img/714-479b10.png";